import { render, staticRenderFns } from "./UserAuthorizationOperationDataTable.vue?vue&type=template&id=4ed65f26&scoped=true&"
import script from "./UserAuthorizationOperationDataTable.vue?vue&type=script&lang=js&"
export * from "./UserAuthorizationOperationDataTable.vue?vue&type=script&lang=js&"
import style0 from "./UserAuthorizationOperationDataTable.vue?vue&type=style&index=0&id=4ed65f26&scoped=true&lang=css&"
import style1 from "./UserAuthorizationOperationDataTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed65f26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataFooter } from 'vuetify/lib/components/VDataIterator';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataFooter,VDataTable})
